<lib-page-load-progress></lib-page-load-progress>

<router-outlet></router-outlet>

<app-aside-outlet [outletName]="asideOutlets.GlobalAsideOutlet"></app-aside-outlet>
